<style>
#ChangeUserGroup .v--modal-box.v--modal {
  min-height: 350px !important;
  min-width: 500px !important;
}
#ChangeUserGroup .v-input__slot,
#ChangeUserGroup .v-select__slot label,
#ChangeUserGroup .v-text-field__slot label {
  font-size: 12px;
}
</style>

<template>
  <Modal
    modalName="ChangeUserGroup"
    @opened="loadGroups"
    @saved="changeUserGroup"
    title="Zmiana grupy użytkownika"
    :buttons="['save']"
  >
    <div class="wrapper">
      <p>W celu przeniesienia użytkownika do innej grupy wybierz ją z poniższej listy, a następnie zatwierdź wybór.</p>
      <v-layout>
        <v-flex xs12>
          <v-select
            label="Nazwa grupy"
            :items="groups"
            item-text="name"
            item-value="gid"
            v-model="userGroup"
            attach="#ChangeUserGroup .v-input__slot"
          ></v-select>
        </v-flex>
      </v-layout>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    userGroup: undefined,
    groups: []
  }),
  computed: {
    currentUserId() {
      return this.$store.getters.getCurrentUserId;
    }
  },
  methods: {
    loadGroups() {
      const self = this;
      this.$store.dispatch("getGroups").then(r => {
        for (let group of r.data.groups) {
          if (group.gname != null) {
            self.groups.push({ name: group.gname, gid: group.id });
          }
        }
        self.groups.push({ name: "Brak", gid: null });
      });
    },
    changeUserGroup() {
      const self = this;
      let payload = {
        uid: this.currentUserId,
        body: {
          usergroup: this.userGroup
        }
      };
      this.$store.dispatch("modifyUser", payload).then(r => {
        if (r) {
          self.$modal.hide("ChangeUserGroup");
          self.$root.$emit("userAssigned");
          self.userGroup = undefined;
        } else {
          self.$root.$emit(
            "showSnackbar",
            "red",
            "Wystapił błąd podczas zmiany grupy"
          );
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/settings/modals/userManagement/ChangeUserGroup.vue